import React, { useContext, useEffect, useState } from "react";
import "react-datetime/css/react-datetime.css";
import Datetime from 'react-datetime';
import axios from 'axios';
import { getDatabase, onValue, ref } from "firebase/database";
import { Accordion, Button, Col, Container, ListGroup, Row, Table } from "react-bootstrap";
import GlobalContext from '../../Components/GlobalContext';
import MainNav from '../../Components/Navbar'
import "react-calendar/dist/Calendar.css";
import '../../css/Presenca.css';
import { useNavigate } from "react-router";
import ApagarPresenca from "./ApagarPresenca";

function Presenca() {
    const [rolls, setRolls] = useState({})
    const [employees, setEmployees] = useState({})
    const [selectedUid, setSelectedUid] = useState("");

    const [professor, setProfessor] = useState("");
    const [company, setCompany] = useState("");
    const [department, setDepartment] = useState("");
    const [roll, setRoll] = useState({});
    const [dateTime, setDateTime] = useState({});

    const [dataPath, setDataPath] = useState("");

    const [selectedProfIndex, setSelectedProfIndex] = useState(null)
    const [selectedRollIndex, setSelectedRollIndex] = useState(null)

    let navigate = useNavigate()

    const [present, setPresent] = useState(0)
    const [away, setAway] = useState(0)
    const [missing, setMissing] = useState(0)

    const { globalData, setGlobalData } = useContext(GlobalContext);

    const db = getDatabase()

    function firebaseToString(value) {
        return String(value)
            .replace(/_/g, ' ')
            .replace(/\*/g, '/')
            .replace(/\+/g, '.');
    }

    useEffect(() => {
        onValue(ref(db, '/rolls/'), (snapshot) => {
            let result = snapshot.val()

            if (result) {
                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: `${globalData.apiHost}/users`,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': process.env.REACT_APP_BACKEND_SECRET
                    },
                    data: Object.keys(result)
                };

                axios.request(config)
                    .then((response) => {
                        const teachers = response.data.users

                        for (let teacher of teachers) {
                            result[teacher.uid]['displayName'] = teacher.displayName;
                            result[teacher.uid]['email'] = teacher.email;
                        }

                        setRolls(result)
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        })
    }, []);

    const changeCompanySelect = (index, uId, professor) => {
        setEmployees({})
        setSelectedProfIndex(index)
        setSelectedRollIndex(null)
        setSelectedUid(uId)
        setProfessor(professor)
    }

    const formatDate = (date) => {
        date = date.replace('-', '/').replace('-', '/').replace('-', ' ')
        return date
    }

    const Print = () => {
        navigate('/impressao', { state: { roll: roll, department: department, professor: professor, company: company, dateTime: dateTime } })
    }

    const selectRoll = (rollData) => {
        let emp = rollData.employees.sort((a, b) => a.employee.localeCompare(b.employee));

        setEmployees(emp)

        const count = rollData.employees.reduce((acc, { status }) => {
            acc[status] = (acc[status] || 0) + 1;
            return acc;
        }, {});

        setPresent(count["PRESENTE"] || 0);
        setAway(count["AUSENTE"] || 0);
        setMissing(count["FALTA"] || 0);
    }

    // Date filter

    const [sDate, setSDate] = useState(null)
    const [eDate, setEDate] = useState(null)

    const [dtPlaceHolderProps, setDtPlaceHolderProps] = useState({
        placeholder: "Selecionar data..."
    })

    const clearDateFilter = () => {
        setSDate(null);
        setEDate(null);
    }

    function isDateInRange(dateStr) {
        const [day, month, year] = dateStr.split('/').map(Number);
        const date = new Date(year, month - 1, day);

        if (sDate && date < sDate) return false;
        if (eDate && date > eDate) return false;
        return true;
    }

    return (
        <>
            <MainNav />
            <Container className="mt-3">
                <Row className="d-flex justify-content-between">
                    <Col md={4} className="d-flex">
                        <div className="px-1">
                            <p className="m-0">Data Início</p>
                            <Datetime value={sDate} onChange={setSDate} dateFormat="DD/MM/YYYY" timeFormat={false} inputProps={dtPlaceHolderProps} />
                        </div>
                        <div className="px-1">
                            <p className="m-0">Data Fim</p>
                            <Datetime value={eDate} onChange={setEDate} dateFormat="DD/MM/YYYY" timeFormat={false} inputProps={dtPlaceHolderProps} />
                        </div>
                    </Col>
                    {/* <Col md={2} className="d-flex align-items-end">
                        <Button variant="danger" onClick={() => clearDateFilter()}>Limpar <i className="bi bi-funnel"></i></Button>
                        <Button className="ms-2">Filtrar <i className="bi bi-funnel-fill"></i></Button>
                    </Col> */}
                </Row>
                <Row className="d-flex  mt-3">
                    <Col md={2}>
                        <h3>Professores</h3>
                        <ListGroup>
                            {Object.entries(rolls).map(([uId, companyData], index) => {
                                return (
                                    <ListGroup.Item
                                        key={index}
                                        onClick={() => {
                                            changeCompanySelect(index, uId, companyData['displayName'])
                                        }}
                                        className={`w-100 prof-item ${index === selectedProfIndex ? "prof-item-selected" : ""}`}
                                    >
                                        {firebaseToString(companyData['displayName'])}
                                    </ListGroup.Item>
                                )
                            })}
                        </ListGroup>
                    </Col>
                    <Col md={3} className="mt-3 mt-md-0">
                        {
                            selectedUid !== "" &&
                            <h3 className="text-start">Presenças</h3>
                        }
                        <Accordion>
                            {
                                selectedUid &&
                                Object.entries(rolls[selectedUid]).map(([companyName, companyRoll], index) => {
                                    if (companyName !== "displayName" && companyName !== "email") {
                                        return <Accordion.Item eventKey={index} onClick={() => {
                                            setCompany(firebaseToString(companyName))
                                        }}>
                                            <Accordion.Header>
                                                {firebaseToString(companyName)}
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <Accordion>
                                                    {
                                                        Object.entries(companyRoll).map(([depName, rollData], index) => {
                                                            rollData = Object.fromEntries(
                                                                Object.entries(rollData).sort(([a], [b]) => {
                                                                    const parsed = (str) => {
                                                                        const [day, month, year, time] = str.split("-");
                                                                        return new Date(`${year}-${month}-${day}T${time}:00`);
                                                                    }
                                                                    return parsed(b) - parsed(a);
                                                                })
                                                            )

                                                            return RowTile(depName, index, rollData, companyName)
                                                        })
                                                    }
                                                </Accordion>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    } else {
                                        return <></>
                                    }
                                })
                            }
                        </Accordion>
                    </Col>
                    <Col md={4}  className="mt-3 mt-md-0">
                        {
                            Object.entries(employees).length > 0 && selectedUid && selectedRollIndex && <>
                                <div className="text-center d-flex justify-content-between mb-2">
                                    <h3 className="">Alunos  </h3>
                                    <div>
                                        {
                                            <ApagarPresenca db={db} path={dataPath}/>
                                        }
                                        {
                                            Object.entries(employees).length > 0 && selectedUid &&
                                            <Button className="" onClick={() => Print()}>
                                                <i className="bi bi-printer-fill"></i>
                                            </Button>
                                        }
                                    </div>
                                </div>
                                <div className="border border-1 rounded px-2 pb-2">
                                    <div className="d-flex justify-content-between">
                                        <Table >
                                            <thead>
                                                <tr>
                                                    <th>Alunos</th>
                                                    <th>Presentes</th>
                                                    <th>Ausentes</th>
                                                    <th>Faltas</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{present + away + missing}</td>
                                                    <td>{present}</td>
                                                    <td>{away}</td>
                                                    <td>{missing}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div style={{ "maxHeight": "600px", "overflowY": "auto" }} className="">
                                        <ListGroup>
                                            {
                                                employees.map((item) => {
                                                    return (
                                                        <ListGroup.Item style={{ "backgroundColor": "#eeeeee" }}>
                                                            <div className="d-flex justify-content-between">
                                                                <div className="d-flex align-items-center" style={{ "maxWidth": "200px" }}>
                                                                    {item.employee}
                                                                </div>
                                                                <div>
                                                                    <IconePresenca tipoPresenca={item.status} />
                                                                </div>
                                                            </div>
                                                        </ListGroup.Item>
                                                    )
                                                })
                                            }
                                        </ListGroup>
                                    </div>
                                </div>
                            </>
                        }
                    </Col>
                </Row>
            </Container >
        </>
    )

    function RowTile(depName, index, rollData, companyName) {
        return <Accordion.Item
            eventKey={depName}
            key={index}
            onClick={() => {
                setDepartment(firebaseToString(depName));
            } }
        >
            <Accordion.Header>
                {firebaseToString(depName)}
            </Accordion.Header>
            <Accordion.Body className="p-0">
                <ListGroup variant="flush">
                    {Object.keys(rollData).map((datetime, index) => {
                        if (rollData[datetime].isRollVisible == false) {
                            return null;
                        }
                        if (isDateInRange(formatDate(datetime).substring(0, 10))) {
                            return (
                                <ListGroup.Item
                                    onClick={() => {
                                        selectRoll(rollData[datetime]);
                                        setRoll(rollData[datetime]);
                                        setDateTime(datetime);
                                        setSelectedRollIndex(index + datetime + depName);
                                        setDataPath(`${selectedUid}/${companyName}/${depName}/${datetime}`);
                                    } }
                                    key={datetime}
                                    className={`date-item ${index + datetime + depName === selectedRollIndex ? "date-item-selected" : ""}`}
                                >
                                    {formatDate(datetime)}
                                </ListGroup.Item>
                            );
                        }
                        return null;
                    })}
                </ListGroup>
            </Accordion.Body>
        </Accordion.Item>;
    }
}

function IconePresenca(props) {
    return (
        <>
            <Button
                variant={props.tipoPresenca == "FALTA" ? "danger" : "secondary"}
                className=" iconePresenca   "
            >
                <i className="bi bi-x-lg text-white"></i>
            </Button>
            <Button
                variant={props.tipoPresenca == "AUSENTE" ? "warning" : "secondary"}
                className=" iconePresenca"
            >
                <img style={{ "color": "yellow" }} src="/static/images/person_off_disabled.svg"></img>
            </Button>
            <Button
                variant={props.tipoPresenca == "PRESENTE" ? "success" : "secondary"}
                className=" iconePresenca"
            >
                <i className="bi bi-check-lg text-white"></i>
            </Button>
        </>
    )
}

export default Presenca